import { Table } from "@4uhub/lib4uhub";
import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IEsignRuleGroup } from "../../../../models/esign-rule-group";
import MainApi from "../../../../services/mainApi.service";

const translationPath = "4uESign.page.automations.signatureGroups.";
const service = new MainApi<IEsignRuleGroup>(
  process.env.REACT_APP_4UESIGN + "/api/v1/ESignRuleGroup/",
);

const AutomationRuleGroupsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const columns: GridColDef<IEsignRuleGroup>[] = [
    { field: "name", headerName: t(translationPath + "name") || "Name" },
  ];

  return (
    <Table<IEsignRuleGroup>
      showDefaultMacroFilters={false}
      service={service}
      columns={columns}
      title={t(translationPath + "title")}
      searchInput
      onRowClick={(params: GridRowParams<IEsignRuleGroup>) =>
        navigate(`${params.id.toString()}/edit`)
      }
      defaultPageSize={20}
      pageSizeOptions={[5, 10, 20]}
      searchInputPlaceHolder={t(translationPath + "search")}
    />
  );
};

export default AutomationRuleGroupsPage;
